const transferStatuses = ['pending%20pickup', 'in%20transit'];

export { transferStatuses };
